import type { ScanView } from "../../api/types.js";
import { deriveScanDiagram, scanDiagramToneLabel } from "./scanCockpit.js";
import "./scan-path-diagram.css";

export function ScanPathDiagram({ scan }: { scan: ScanView }) {
  const diagram = deriveScanDiagram(scan);
  return (
    <ol
      className="scan-path-diagram"
      data-testid="scan-path-diagram"
      data-outcome={diagram.outcome}
      data-gate={diagram.gateLocked ? "locked" : "open"}
      aria-label="Static scan path"
    >
      {diagram.nodes.map((node) => (
        <li
          key={node.id}
          className={`scan-path-diagram__node scan-path-diagram__node--${node.tone}`}
          data-node={node.id}
          data-tone={node.tone}
          aria-label={`${node.label}: ${scanDiagramToneLabel(node.tone)}`}
        >
          <strong>{node.label}</strong>
          <span className="scan-path-diagram__tone">{scanDiagramToneLabel(node.tone)}</span>
        </li>
      ))}
    </ol>
  );
}
